import {
  QRCodePayload,
} from '../app/types'

export const parseJson = (item: any): QRCodePayload | false => {
  let value = typeof item !== 'string' ? JSON.stringify(item) : item
  try {
    value = JSON.parse(value)
  } catch (e) {
    return false
  }

  if (typeof value !== 'object') {
    // parsing it twice since atob will sometimes return "over-stringified" string, with escaped quotes
    value = JSON.parse(value)
  }

  return typeof value === 'object' && value !== null
    ? value
    : false
}

export const doAtob = (value: string): number | string | null => {
  try {
    return atob(value)
  } catch (e) {
    return null
  }
}
